import { useRef } from "react";

// Horizontal pointer drag vs click on an element; reports fractions of its width
export const useDrag = ({ onDown, onDrag, onEnd, onClick }) => {
  const s = useRef(null);
  const frac = (e, r) => Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
  return {
    onPointerDown: (e) => {
      const r = e.currentTarget.getBoundingClientRect();
      s.current = { x: e.clientX, r, f0: frac(e, r), moved: false, ctx: onDown?.() };
      e.currentTarget.setPointerCapture?.(e.pointerId);
    },
    onPointerMove: (e) => {
      const d = s.current;
      if (!d || (!d.moved && Math.abs(e.clientX - d.x) < 4)) return;
      d.moved = true;
      onDrag(d.ctx, d.f0, frac(e, d.r), (e.clientX - d.x) / d.r.width);
    },
    onPointerUp: (e) => {
      const d = s.current;
      s.current = null;
      if (!d) return;
      if (d.moved) onEnd?.(d.ctx, d.f0, frac(e, d.r));
      else onClick?.(frac(e, d.r));
    },
  };
};
